import { parentesco } from '@utils';
import {
  commons,
  death,
  parents,
  spouses,
  childs,
  certidaoGenitor,
  convivente,
  casoUniaoEstavel,
  others,
  menorTutela,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const HerdeiroLegalANDocs = () => {
  const rules = {
    anexoOutros: dynamicRule(),
    // anexoHerdeiro: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    // anexoDeclaracaoHerdeiros: dynamicRule('required'),
    anexoCertidaoDeObito: dynamicRule('required'),

    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),
    anexoTermoTutelaJudicial: dynamicRule('menorTutela'),
  };

  const docs = {
    commons: [...commons],
    others: [...others],
    [constants.PAI]: [...death, ...parents],
    [constants.MAE]: [...death, ...parents],
    [constants.CONJUGE]: [...death, ...spouses],
    [constants.EX_CONJUGE]: [...death, ...spouses],
    [constants.FILHO]: [...death, ...childs],
    [constants.CONVIVENTE]: [...death, ...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...death, ...childs, ...certidaoGenitor],
    [constants.MENOR_TUTELA]: [...childs, ...menorTutela, ...death],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
